import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  row: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "10px",
  },
}));

export default styles;
